module.exports = __webpack_public_path__ + "static/media/ResumeCopy.c9620616.pdf";